<script setup lang="ts">
import type { MenuItem } from 'primevue/menuitem';

/**
 * Renders a PrimeVue Menu/SplitButton item that can be visually "blocked".
 *
 * A blocked item stays in the DOM and keeps emitting hover events (so its `tooltip`
 * can explain why it is unavailable) while the inner link is greyed and click-disabled.
 * When `item.blocked` is falsy this renders an ordinary, fully-interactive menu item,
 * so dropping it into a menu has no behavioural effect on un-blocked items.
 */
defineProps<{
  item: MenuItem;
  /** The PrimeVue item-slot `props.action` binding (click + a11y attributes). */
  actionProps: object;
}>();
</script>
<template>
  <!-- Tooltip lives on the wrapper because a click-disabled link no longer emits hover events. -->
  <div v-tooltip.left="item.tooltip" :class="{ 'opacity-60': item.blocked }">
    <a v-ripple v-bind="actionProps" :class="{ 'pointer-events-none': item.blocked }">
      <span v-if="item.icon" class="p-menu-item-icon" :class="item.icon" />
      <span class="p-menu-item-label">{{ item.label }}</span>
    </a>
  </div>
</template>
